
<template>
    <div class="flex min-h-full h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 ">


        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm bg-white p-5 rounded-md">
            <form class="space-y-6" action="#" method="POST" @submit.prevent="login">
                <div>
                    <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email</label>
                    <div class="mt-2">
                        <input id="email" name="email" type="email" autocomplete="email" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6" v-model="form.email" />
                    </div>
                </div>

                <div>
                    <div class="flex items-center justify-between">
                        <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password</label>
                        <!-- <div class="text-sm">
                            <a href="#" class="font-semibold text-primary-600 hover:text-primary-500">Forgot password?</a>
                        </div> -->
                    </div>
                    <div class="mt-2">
                        <input id="password" name="password" type="password" autocomplete="current-password" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6" v-model="form.password" />
                    </div>
                </div>

                <div>
                    <button type="submit" class="flex w-full justify-center rounded-md bg-primary-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 my-3">Login</button>
                                        <router-link to="/" type="button" class="flex w-full justify-center rounded-md bg-primary-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">Cancel</router-link>
                </div>
            </form>
            <div v-if="isAuth" class="py-5">
                <div class="rounded-md bg-green-50 p-4">
                    <div class="flex">
                        <div class="ml-3">
                            <h3 class="text-sm font-medium text-green-900">Logged in</h3>
                            <div class="mt-4">
                                <div class="-mx-2 -my-1.5 flex">
                                    <router-link to="/" type="button" class="rounded-md bg-green-50 px-2 py-1.5 text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50">Back</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="myError" class="py-5">
                <div class="rounded-md bg-red-50 p-4">
                    <div class="flex">
                        <div class="ml-3 text-red-900">
                            <h3 class="text-xl font-medium text-red-900">Error</h3>
                            <div>{{ myError }}</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script setup>
import { reactive, ref, inject } from 'vue';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { initializeApp } from 'firebase/app';
import { setAuth } from '@/core/modules';

const firebaseConfig = inject('firebaseConfig')
const form = reactive({ email: null, password: null });
const isAuth = ref(false);
const myError = ref(false);


const login = () => {

    const app = initializeApp(firebaseConfig);

    const auth = getAuth(app);
    signInWithEmailAndPassword(auth, form.email, form.password)
        .then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            isAuth.value = true;
            setAuth(user.accessToken)
            myError.value = false;

        })
        .catch((error) => {
            //const errorCode = error.code;
            const errorMessage = error.code;
            //console.log(errorMessage);
            myError.value = errorMessage;
        });
}
</script>